export default {
  label: {
    shop: '商城',
    selectedShop: '已选商城',
    selectedBrand: '已选品牌',
    selectedCategory: '已选分类',
    SelectedFormat: '已选模板',
  },
  page: {
    myShop: '主商城',
    screenText: '筛选',
    searchPlaceholder: '请输入搜索内容',
    viaText: '上传查询商品',
    clearBtnText: '清除',
    submitText: '搜索',
    addToExport: '加入下载',
    rest: '清空',
    next: '下一步',
    noData: '暂无数据',
    loading: '正在加载... ...',
    selectShopMsg: '请选择商城',
    selectFormatMsg: '选择下载模板',
    selectCategoryMsg: '选择下载品类',
    selectBrandMsg: '选择品牌',
    fileSearchMsg: '当前文件无法搜索出结果',
  },
  selectShopFilter: {
    title: '筛选条件',
  },
  exportFilter: {
    title: '筛选条件',
    historyBtn: '历史条件',
    skipBtn: '跳过',
    confirmBtn: '确认',
    fileNameInfo: '请输入下载文件名',
    fileNameRuleMsg: '文件名不能包含特殊字符',
    selectShopMsg: '请选择商城！',
    selectDateMsg: '请选择时间区间！',
    fileNameMsg: '请输入文件名称',
    dateChangeMsg: '选择正确时间',
    selectGood: '请选择商品!',
    historyModal: {
      title: '历史条件',
      no: 'No.',
      name: '名称',
      date: '日期',
      operation: '操作',
      choose: '选择',
      colse: '粘贴',
    },
  },
};
